import React from 'react';
import Printer from '../../images/printer.svg';
import SeriesIcon from '../../images/squares-four.svg';
import X from '../../images/x.svg';
import Back from '../../images/arrow-u-down-left.svg'
import { GetProgress, GetProgressList, PrintAllJobs } from '../../service/ServiceJob';
import { v4 as uuidv4 } from 'uuid';
import i18n from "../../i18n";

export function Header({ props, listJobs, styles, fn, isOpen, fnPrintAll, setIsLoading, setMsgLoading }) {

    const isMobile = window.mobilecheck();

    function back(e) {
        e.preventDefault();
        props.history.push('/portal');
    }

    async function printAll() {
        setIsLoading(true);
        setMsgLoading(i18n.t("PORTAL.COMPONENT.GENERATING_PDF"));

        let intervalo;

        try {
            const listIds = await fnPrintAll();

            intervalo = setInterval(async () => {
                try {
                    const progress = await GetProgressList(listIds[0]);
                    if (progress.data.progress === 100) {
                        setMsgLoading(i18n.t("PORTAL.COMPONENT.FINALIZING"));
                    }
                } catch (error) {
                    console.error('Erro ao buscar progresso', error);
                }
            }, 3000)

            const response = await PrintAllJobs(listIds);

            if (isMobile) {
                const nameFile = uuidv4();
                const file = new File([response.data], `${nameFile}.pdf`, { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(file);
                var fileLink = document.createElement('a');
                fileLink.href = pdfUrl;
                fileLink.download = `${nameFile}.pdf`;
                fileLink.click();
                setIsLoading(false);
            } else {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const pdfUrl = URL.createObjectURL(blob);
                window.open(pdfUrl);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Erro ao imprimir todos job', error);
        } finally {
            clearInterval(intervalo);
            setIsLoading(false);
        }
    }

    return (
        <header className={styles.header}>
            {isMobile && (
                <div className={styles.seriesMobile}>
                    <button onClick={fn}>
                        {isOpen ? <img src={Back} /> : <img src={SeriesIcon} />}
                    </button>
                    {!isOpen && <span style={{fontSize: '10px'}}>{i18n.t("PORTAL.COMPONENT.DOCUMENTS")}</span>}
                </div>
            )}
            <div className={styles.actions}>
                {listJobs.length > 0 && (
                    <button
                        title={i18n.t("PORTAL.COMPONENT.PRINT")}
                        className={styles.print}
                        onClick={() => printAll()}
                    >
                        <img src={Printer} width={24} /> {i18n.t("PORTAL.COMPONENT.PRINT_ALL_DOCUMENTS")}
                    </button>)}
                <button
                    onClick={(e) => back(e)}
                    title={i18n.t("PORTAL.BUTTON.CLOSE")}
                    className={styles.close}
                >
                    <img src={X} width={24} />
                </button>
            </div>
        </header>
    );
}
